// extracted by mini-css-extract-plugin
export default {"parent":"formSwitch_parent__TYXse","parentLabel":"formSwitch_parentLabel__c+5e2","parentErrorInform":"formSwitch_parentErrorInform__1pAPU"};